import { render, staticRenderFns } from "./ConfirmTerm.vue?vue&type=template&id=3cfe9d7d&scoped=true&"
var script = {}
import style0 from "./ConfirmTerm.vue?vue&type=style&index=0&id=3cfe9d7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfe9d7d",
  null
  
)

export default component.exports